/**
 * Created by Administrador on 19/09/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('segmentFlightService', segmentFlightService);

    segmentFlightService.$inject = ['$http', 'CONFIG', 'messageService'];

    function segmentFlightService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/segmentFlight' ;
        var service = {
            getSegmentFlightsByFlightOrConnection: getSegmentFlightsByFlightOrConnection,
            getSegmentByOriginDestinyDepartureDate: getSegmentByOriginDestinyDepartureDate,
            getSegmentByOriginDestinyDate: getSegmentByOriginDestinyDate,
            getSegmentFlight: getSegmentFlight
        }

        return service;

        function getSegmentFlightsByFlightOrConnection(id, isConnection){
            return $http.get(urlBase + "/byFlightOrConnection/?id=" + id + "&isConnection=" + isConnection)
                .then(function(response){
                    return (response.data) ? response.data : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getSegmentByOriginDestinyDepartureDate(originId, destinyId, departureDate){
            return $http.get(urlBase + "/byOriginDestinyDepartureDate/?originId=" + originId + "&destinyId=" + destinyId + "&departureDate="+departureDate + "&withRestriction=false")
                .then(function(response){
                    return (response.data) ? response.data : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getSegmentByOriginDestinyDate(originId, destinyId, departureDate){
            return $http.get(urlBase + "/byOriginDestinyDate/?originId=" + originId + "&destinyId=" + destinyId + "&departureDate="+departureDate + "&withRestriction=true")
                .then(function(response){
                    return (response.data) ? response.data : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getSegmentFlight(segmentFlightId){
            return $http.get(urlBase + "/"+segmentFlightId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }
    }
})();

